<template>
  <div class="wrapper panel-with-actions">
    <thux-list-component
      :fields="getFields"
      :pagination="getPaginationFields"
      @select-per-page="changePerPage({ perPage: $event, id: uploadDocumentId })"
      @change-page="changePage({ page: $event, id: uploadDocumentId })"
      :action-select="getActionSelectFields"
      @select-action="setAction"
      @select-or-deselect-all-queryset="selectOrDeselectAllQueryset"
      @do-action="doAction($event, fieldName)"
      :advanced-search="getAdvancedSearchFields"
      @show-advanced-search="openAdvancedSearch"
      @open-edit-form="openEditForm()"
      @open-detail-form="openDetailForm()"
    >
      <template slot="body">
        <component-table
          :list="list.results"
          :goBack="goBack"
          :params="tableParams"
        />
      </template>
    </thux-list-component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ThuxListMixin from '../../../../components/thux-list/ThuxListMixin'
import { TYPES as UPLOAD_DOCUMENT_HISTORY_TYPES } from './store'
import UploadDocumentHistoryTable from './UploadDocumentHistoryTable'

export default {
  name: 'UploadDocumentHistoryList',
  props: { uploadDocumentId: { required: true } },
  mixins: [ThuxListMixin],
  components: {
    'component-table': UploadDocumentHistoryTable
  },
  data () {
    return {
      searchFields: [],
      rolePerm: ['document_uploaddocument_history'],
      showCommonFilters: false
    }
  },
  computed: {
    ...mapGetters({
      ...UPLOAD_DOCUMENT_HISTORY_TYPES.GENERIC.document.uploaddocumenthistory.LIST.GETTERS
    }),
    showList () {
      return true
    },
    canSeeActionSelect () {
      return false
    },
    canAddInstance () {
      return false
    }
  },
  methods: {
    ...mapActions({
      ...UPLOAD_DOCUMENT_HISTORY_TYPES.GENERIC.document.uploaddocumenthistory.LIST.ACTIONS
    }),
    getComponentList () {
      this.setFilters({ id: this.uploadDocumentId, filters: {} })
    }
  }
}
</script>
